/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ActionKind = {
    NotifyParticipants: 'NOTIFY_PARTICIPANTS',
    SendMessage: 'SEND_MESSAGE'
} as const;
export type ActionKind = typeof ActionKind[keyof typeof ActionKind];


export function instanceOfActionKind(value: any): boolean {
    for (const key in ActionKind) {
        if (Object.prototype.hasOwnProperty.call(ActionKind, key)) {
            if (ActionKind[key as keyof typeof ActionKind] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ActionKindFromJSON(json: any): ActionKind {
    return ActionKindFromJSONTyped(json, false);
}

export function ActionKindFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActionKind {
    return json as ActionKind;
}

export function ActionKindToJSON(value?: ActionKind | null): any {
    return value as any;
}

export function ActionKindToJSONTyped(value: any, ignoreDiscriminator: boolean): ActionKind {
    return value as ActionKind;
}

